import { makeStyles, createStyles } from "@material-ui/styles"
// import { emphasize } from "@material-ui/core/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    list: {
      maxHeight: "225px",
      overflow: "scroll",
      marginTop: theme.spacing(),
      marginBottom: theme.spacing(),
    },
    suggestedCrewItem: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
      cursor: "pointer",
    },
    spinnerContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(4),
    },
  })
)

export default useStyles
